import { getBaseDomain, getRegisteredDomain } from "../SharedTransforms";

export function resolvePrimitiveImageUrl(primitive, fallbackLabel) {
  if (!primitive) {
    return null;
  }
  if (primitive.type !== "entity" && primitive.type !== "result") {
    return null;
  }
  if (primitive.referenceId === 78 || primitive.referenceId === 34) {
    const remoteCandidates = [
      primitive.referenceParameters?.url,
      primitive.referenceParameters?.link,
      primitive.referenceParameters?.sourceUrl,
      primitive.referenceParameters?.source_url,
      primitive.referenceParameters?.articleUrl,
      primitive.referenceParameters?.article_url,
      primitive.referenceParameters?.storyUrl,
      primitive.referenceParameters?.story_url,
      primitive.referenceParameters?.image,
      primitive.metadata?.url,
      primitive.metadata?.link,
      primitive.metadata?.sourceUrl,
      primitive.metadata?.source_url,
      primitive.url,
    ]
      .map((value) => (typeof value === "string" ? value.trim() : ""))
      .filter((value) => value.length > 0);
    if (remoteCandidates.length > 0) {
      return `/api/preview?url=${encodeURIComponent(remoteCandidates[0])}`;
    }
  }
  const querySuffix = primitive.imageCount ? `?${primitive.imageCount}` : "";
  if (primitive.referenceParameters?.hasImg || primitive.imageCount) {
    return `/api/image/${primitive.id}${querySuffix}`;
  }
  const directSources = [
    primitive.referenceParameters?.imageUrl,
    primitive.referenceParameters?.main_image,
    primitive.referenceParameters?.logoUrl,
    primitive.referenceParameters?.logo_url,
    primitive.referenceParameters?.logo,
    primitive.referenceParameters?.avatarUrl,
    primitive.referenceParameters?.avatar,
    primitive.referenceParameters?.photoUrl,
    primitive.referenceParameters?.photo,
    primitive.referenceParameters?.profile_image_url,
    primitive.referenceParameters?.profile_image_link,
    primitive.referenceParameters?.profileImageUrl,
    primitive.referenceParameters?.image,
  ].filter((value) => typeof value === "string" && value.trim().length > 0);

  if (directSources.length > 0) {
    return `/api/remoteImage?url=${encodeURIComponent(directSources[0])}`;
  }

  const domainSource =
    primitive.referenceParameters?.domain ??
    primitive.referenceParameters?.url ??
    primitive.referenceParameters?.website;
  if (typeof domainSource === "string" && domainSource.trim().length > 0) {
    const domain =
      getRegisteredDomain(domainSource) ??
      getBaseDomain(domainSource) ??
      domainSource.trim();
    if (domain) {
      return `/api/companyLogo?domain=${encodeURIComponent(domain)}`;
    }
  }

  const finalLabel = primitive.title ?? fallbackLabel;
  if (finalLabel) {
    return `/api/companyLogo?name=${encodeURIComponent(finalLabel)}`;
  }
  return null;
}
